/* eslint-disable no-unused-vars */
export enum DisclosureTypeEnum {
    Manuscript = 1,
    Abstract = 2,
    Poster = 3,
    Presentation = 4,
    Thesis = 5,
    SummaryOfResults = 6,
    Other = 7,
}

export const DisclosureTypeEnumKey = {
    [DisclosureTypeEnum.Manuscript]: 'Manuscript',
    [DisclosureTypeEnum.Abstract]: 'Abstract',
    [DisclosureTypeEnum.Poster]: 'Poster',
    [DisclosureTypeEnum.Presentation]: 'Presentation',
    [DisclosureTypeEnum.SummaryOfResults]: 'Summary of Results',
    [DisclosureTypeEnum.Thesis]: 'Thesis',
    [DisclosureTypeEnum.Other]: 'Other',
};
